import { render, staticRenderFns } from "./ModalDeleteDocument.vue?vue&type=template&id=7ef4d45c&"
import script from "./ModalDeleteDocument.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports